import script from "./mixin.vue?vue&type=script&lang=js"
export * from "./mixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__